import React from "react"
import PropTypes from "prop-types"
import Header from "./Header"

const HeaderRow = ({ data, header }) => (
  <thead className="bookmark-widget-table-thead">
    <tr className="bookmark-widget-table-tr">
      {data.data.columns
        .filter((col) => !col.hidden)
        .map((column, id) => (
          <Header
            value={column.text}
            style={header && header.props.children[id].props.style}
            className={header && header.props.children[id].props.className}
            key={column.text}
          />
        ))}
    </tr>
  </thead>
)

HeaderRow.propTypes = {
  data: PropTypes.object.isRequired,
  header: PropTypes.object
}
HeaderRow.defaultProps = {
  header: undefined
}

export default HeaderRow
